import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { richT } from "@thelabnyc/thelabui/src/utils/richText";

import styles from "../../styles/composable/forms.module.scss";

type IProps = Immutable<{
    loginUrl: string;
    resetUrl: string;
}>;

/**
 * The duplicate-email registration affordance: rendered below the email
 * field's error list when the server flags the "duplicate_email" error code.
 * The error message itself stays plain text (HTML in error strings gets
 * escaped by the client error lists); the links live here as real elements.
 * One msgid via richT so translators see the whole sentence with the link
 * text in context.
 */
export const DuplicateEmailError = (props: IProps): React.JSX.Element => (
    <p
        className={styles.formErrorAffordance}
        data-testid="duplicate-email-error"
    >
        {richT(
            t`Please <login>log in</login> or <reset>reset your password</reset>.`,
            {
                login: (children) => (
                    <a key="login" href={props.loginUrl}>
                        {children}
                    </a>
                ),
                reset: (children) => (
                    <a key="reset" href={props.resetUrl}>
                        {children}
                    </a>
                ),
            },
        )}
    </p>
);

/**
 * The `FormFields afterField` entry the FormFields-based registration bodies
 * share: the affordance under the email field when the server flagged the
 * duplicate. Cocoon renders the leaf inline (its body hand-rolls the field
 * loop).
 */
export const duplicateEmailAfterField = (
    props: Immutable<{
        duplicate_email: boolean;
        login_url: string;
        reset_url: string;
    }>,
): Partial<Record<string, React.ReactNode>> => ({
    email: props.duplicate_email ? (
        <DuplicateEmailError
            loginUrl={props.login_url}
            resetUrl={props.reset_url}
        />
    ) : null,
});
